/*
 * 文件EN: APIList.js,
 * 文件CN: 项目列表,
 * 创建时间: Wednesday, 17th June 2020 9:56:15 am,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

import * as Models from '@/api/T9/APIList'

export default {
  namespaced: true,
  actions: {
    // 获取列表
    async getList(ctx, payload) {
      return await Models.getListData(payload).then(res => {
        return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
      })
    },
    // 获取详情
    async getDetails(ctx, payload) {
      return await Models.fetchDetails(payload).then(res => {
        return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
      })
    },
    // Api项目列表 - 请求参数查询
    async queryApiReqParam(ctx, payload) {
      return await Models.queryApiReqParam(payload).then(res => {
        return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
      })
    },
    // Api项目列表 - 返回参数查询
    async queryApiParam(ctx, payload) {
      return await Models.queryApiParam(payload).then(res => {
        return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
      })
    },
    // 错误码列表 返回参数 请求参数 成功示例
    async queryParams(ctx, payload) {
      return await Models.queryParams(payload).then(res => {
        return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
      })
    },
    // 调用权限列表的查询
    async queryApiAuthorizeList(ctx, payload) {
      return await Models.queryApiAuthorizeList(payload).then(res => {
        return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
      })
    },
    // 新增 修改 操作
    // Api项目列表 - 修改
    async updateApi(ctx, payload) {
      return await Models.updateApi(payload).then(res => {
        return (res.status === 200) && Promise.resolve(res) || Promise.reject(`data: ${null}`)
      })
    },
    // Api项目列表 - 新增
    async saveapi(ctx, payload) {
      return await Models.saveapi(payload).then(res => {
        return (res.status === 200) && Promise.resolve(res) || Promise.reject(`data: ${null}`)
      })
    },
    // Api项目列表 - 启用
    async onStart(ctx, payload) {
      return await Models.onStart(payload).then(res => {
        return (res.status === 200) && Promise.resolve(res) || Promise.reject(`data: ${null}`)
      })
    },
    // Api项目列表 - 停用
    async onStop(ctx, payload) {
      return await Models.onStop(payload).then(res => {
        return (res.status === 200) && Promise.resolve(res) || Promise.reject(`data: ${null}`)
      })
    }
  }
}
